import React from "react";
import SEO from "../components/SEO";
import { PAGES } from "../seo/pages.config";
import Breadcrumb from "../components/Breadcrumb";
import CaseStudyArea from "../components/CaseStudyArea";
import FooterOne from "../components/FooterOne";
import NavBar from "../components/NavBar";

const CaseStudyDetails = () => {
  return (
    <>
      <SEO canonical="/case-study-details" {...PAGES["/case-study-details"]} />
      {/* Navigation Bar */}
      <NavBar />

      {/* Navigation Bar */}
      <Breadcrumb title={"Case Study Details"} />

      {/* Case Study Area */}
      <CaseStudyArea />

      {/* Footer One */}
      <FooterOne />
    </>
  );
};

export default CaseStudyDetails;
